/* eslint-disable max-lines */
/* eslint-disable radix */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { Select, Button, Loader, Card } from 'sa-ui';
import queryString from 'query-string';
import BubbleChart from 'react-apexcharts';
import * as xlsxUtil from 'app/utils/xlsx';

import messages from './reportGeneralPanelTRIMessages';
import * as actions from '../reportsActions';
import * as generalTRIActions from './reportGeneralPanelTRIActions';
import * as helpers from './reportGeneralPanelTRIHelpers';

import { promisify } from '../../app/actions';

import PerformanceStudentsComparative from '../PerformanceStudentsComparative';

import './ReportGeneralPanelTRIContainer.scss';
import GeneralDetailCard from './GeneralDetailCard';
import StudentDetailCard from './StudentDetailCard';
import AvgRankingTable from '../AvgRankingTable';
import Chart from '../ReportBarChart';
import ChartPerformance from '../GenericReportBarChart';
import AssessmentCycleTable from '../AssessmentCycleTable';

function getInitialLimit() {
  const params = queryString.parse(window.location.search.replace('?', ''));
  return params.limit ? Number(params.limit) : 15;
}

function getInitialExpanded() {
  const params = queryString.parse(window.location.search.replace('?', ''));
  return params.expanded ? params.expanded : false;
}

const ReportGeneralPanelTRIContainer = (props) => {
  const [filter, setFilter] = useState(queryString.parse(window.location.search.replace('?', '')));
  const [networkOptions, setNetworkOptions] = useState([]);
  const [evaluationOptions, setEvaluationOptions] = useState([]);
  const [schoolOptions, setSchoolOptions] = useState([]);
  const [courseOptions, setCourseOptions] = useState([]);
  const [studentOptions, setStudentOptions] = useState([]);
  const [studentName, setStudentName] = useState('');
  const [schoolName, setSchoolName] = useState({ name: '' });
  const [networkName, setNetworkName] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingApi, setLoadingApi] = useState(false);
  const [curricularPerformance, setCurricularPerformance] = useState([]);
  const [studentGrade, setStudentGrade] = useState([]);
  const [performanceComparison, setPerformanceComparison] = useState([]);
  const [performanceComparisonByArea, setPerformanceComparisonByArea] = useState([]);
  const [performanceComparisonByAreaStudent, setPerformanceComparisonByAreaStudent] = useState([]);
  const [reportStudentCicleTRI, setReportStudentCicleTRI] = useState([]);
  const [bubbleChartCH, setBubbleChartCH] = useState([]);
  const [bubbleChartCN, setBubbleChartCN] = useState([]);
  const [bubbleChartMT, setBubbleChartMT] = useState([]);
  const [bubbleChartLC, setBubbleChartLC] = useState([]);
  const [filterSchools, setFilterSchools] = useState([]);
  const [showBubbleLegend, setShowBubbleLegend] = useState(false);
  const [avgGeneral, setAvgGeneral] = useState(null);
  const [apisEnded, setApisEnded] = useState(false);
  const [limit, setLimit] = useState(getInitialLimit);
  const [expanded, setExpanded] = useState(getInitialExpanded);

  async function handleExportXLSX() {
    let xlsxData = [];

    if (filter.idCSchool && filter.idESCourse) {
      xlsxData = [
        [
          props.intl.formatMessage(messages.studentName),
          'LC',
          'CH',
          'CN',
          'MT',
          props.intl.formatMessage(messages.writing),
          props.intl.formatMessage(messages.avgObj),
          `${props.intl.formatMessage(messages.avg)} ( ${props.intl.formatMessage(
            messages.objective,
          )} + ${props.intl.formatMessage(messages.writing)} )`,
        ],
      ].concat(
        performanceComparison.map((data) => [
          data.studentName,
          data.LCGrade,
          data.CHGrade,
          data.CNGrade,
          data.MTGrade,
          data.writing ? data.writing : '-',
          data.avgGrade ? data.avgGrade : '-',
          data.avgGradeWriting ? data.avgGradeWriting : '-',
        ]),
      );
    } else {
      xlsxData = [
        [
          props.intl.formatMessage(messages.studentName),
          props.intl.formatMessage(messages.class),
          'LC',
          'CH',
          'CN',
          'MT',
          props.intl.formatMessage(messages.writing),
          props.intl.formatMessage(messages.avgObj),
          `${props.intl.formatMessage(messages.avg)} ( ${props.intl.formatMessage(
            messages.objective,
          )} + ${props.intl.formatMessage(messages.writing)} )`,
        ],
      ].concat(
        performanceComparison.map((data) => [
          data.studentName,
          data.groupName,
          data.LCGrade,
          data.CHGrade,
          data.CNGrade,
          data.MTGrade,
          data.writing ? data.writing : '-',
          data.avgGrade ? data.avgGrade : '-',
        ]),
      );
    }

    xlsxUtil.exportXLSX(
      xlsxData,
      props.intl.formatMessage(messages.tabname),
      `${props.intl.formatMessage(messages.filename)}-${
        filter.idESCourse ? filter.idESCourse : filter.idCSchool
      }.xlsx`,
      true, // Style
    );
  }

  async function handleAPIsTRI(idContract, idEvaluation, idCSchool, idESCourse, idESUser) {
    setLoadingApi(true);
    try {
      if (idContract && idEvaluation && idCSchool && idESCourse && idESUser) {
        await props.getESStudentReportTRI({
          idContract,
          idEvaluation,
          idCSchool,
          idESCourse,
          idStudent: idESUser,
        });
        await props.getESTRIStudentDetail({
          idContract,
          idEvaluation,
          idCSchool,
          idESCourse,
          idStudent: idESUser,
        });
        await props.getESEvaluationsCicleStudentTRI({
          idContract,
          idEvaluation,
          idCSchool,
          idESCourse,
          idStudent: idESUser,
        });
      }
      if (idContract && idEvaluation && !idCSchool && !idESCourse && !idESUser) {
        await props.getESApplicationReportTRI({ idContract, idEvaluation });
        await props.getESTRIApplicationDetail({ idContract, idEvaluation });
        setShowBubbleLegend(false);
      }
      if (idContract && idEvaluation && idCSchool && !idESCourse && !idESUser) {
        await props.getESSchoolReportTRI({ idContract, idEvaluation, idCSchool });
        await props.getESTRISchoolDetail({ idContract, idEvaluation, idCSchool });
        await props.generateSchoolReportTRI({ idContract, idEvaluation, idCSchool });
        setShowBubbleLegend(false);
      }
      if (idContract && idEvaluation && idCSchool && idESCourse && !idESUser) {
        await props.getESTRIDetail({ idContract, idEvaluation, idCSchool, idESCourse });
        await props.getESReportTRI({ idContract, idEvaluation, idCSchool, idESCourse });
        await props.generateReportTRI({ idContract, idEvaluation, idCSchool, idESCourse });
        setShowBubbleLegend(true);
      }
    } finally {
      setLoadingApi(false);
    }
  }

  async function handleGetFilterTRI(idContract, idEvaluation, idCSchool, idESCourse, idESUser) {
    setLoading(true);
    setApisEnded(false);
    try {
      await handleAPIsTRI(idContract, idEvaluation, idCSchool, idESCourse, idESUser);
      if (idContract || (!idContract && !idEvaluation && !idCSchool && !idESCourse && !idESUser)) {
        await props.getESFilterTRI({ idContract });
      }
      if (idEvaluation && !idCSchool && !idESCourse && !idESUser) {
        await props.getESFilterTRI({ idESEvaluation: idEvaluation });
      }
      if (idCSchool && !idESCourse && !idESUser) {
        await props.getESFilterTRI({ idCSchool });
      }
      if (idESCourse && !idESUser) {
        await props.getESFilterTRI({ idESCourse });
      }
    } finally {
      setLoading(false);
      setApisEnded(true);
    }
  }

  useEffect(() => {
    handleGetFilterTRI();
  }, []);

  useEffect(() => {
    if (apisEnded) {
      setTimeout(() => {
        // sinaliza para o puppeteer renderizar pdf
        window.dispatchEvent(new CustomEvent('app-ready'));
      });
    }
  }, [apisEnded]);

  async function generatePdf() {
    setLoading(true);
    try {
      await props.generatePdf({
        filename: `${props.intl.formatMessage(messages.title)}.pdf`,
        host: `${window.location.protocol}//${window.location.host}`,
        path: window.location.pathname,
        params: { ...filter, limit: 100, expanded: true },
        token: props.token,
      });
    } finally {
      setLoading(false);
    }
  }

  function goBack() {
    props.history.goBack();
  }

  function handleChangeNetwork(event) {
    setFilter({
      ...filter,
      idNetwork: event.target.value,
      idEvaluation: undefined,
      idCSchool: undefined,
      idESCourse: undefined,
      idESUser: undefined,
    });
  }

  function handleChangeEvaluation(event) {
    setFilter({
      ...filter,
      idEvaluation: event.target.value,
      idCSchool: undefined,
      idESCourse: undefined,
      idESUser: undefined,
    });
  }

  function handleChangeSchool(event) {
    setFilter({
      ...filter,
      idCSchool: event.target.value,
      idESCourse: undefined,
      idESUser: undefined,
    });
  }

  function handleChangeCourse(event) {
    setFilter({
      ...filter,
      idESCourse: event.target.value,
      idESUser: undefined,
    });
  }

  function handleChangeStudent(event) {
    setFilter({
      ...filter,
      idESUser: event.target.value,
    });
  }

  function toCurricularPerformanceSeries(curricularPerformanceSeries) {
    if (!curricularPerformanceSeries || curricularPerformanceSeries.length === 0) return [];
    return curricularPerformanceSeries.map((g, index) => ({
      name: g.Name,
      data: g.average,
      average: g.schoolAverage,
      index,
    }));
  }

  useEffect(() => {
    if (props.filterTRI.networks && props.filterTRI.networks.length === 1) {
      setNetworkName(props.filterTRI.networks[0].name);
      setFilter({
        ...filter,
        idNetwork: props.filterTRI.networks[0].idContract,
      });
    }
  }, [props.filterTRI.networks]);

  useEffect(() => {
    handleGetFilterTRI(
      filter.idNetwork || undefined,
      filter.idEvaluation || undefined,
      filter.idCSchool || undefined,
      filter.idESCourse || undefined,
      filter.idESUser || undefined,
    );
  }, [filter.idNetwork, filter.idEvaluation, filter.idCSchool, filter.idESCourse, filter.idESUser]);

  useEffect(() => {
    if (props.filterTRI.networks) {
      setNetworkOptions(helpers.getNetworkOptions(props.filterTRI.networks));
    }
    if (props.filterTRI.evaluations) {
      setEvaluationOptions(helpers.getEvaluationOptions(props.filterTRI.evaluations));
    }
    if (props.filterTRI.schools) {
      setSchoolOptions(helpers.getSchoolOptions(props.filterTRI.schools));
    }
    if (props.filterTRI.courses) {
      setCourseOptions(helpers.getCourseOptions(props.filterTRI.courses));
    }
    if (props.filterTRI.students) {
      setStudentOptions(helpers.getStudentOptions(props.filterTRI.students));
    }
  }, [
    props.filterTRI.networks,
    props.filterTRI.evaluations,
    props.filterTRI.schools,
    props.filterTRI.courses,
    props.filterTRI.students,
  ]);

  const options = {
    chart: {
      height: 500,
      type: 'scatter',
      zoom: {
        enabled: true,
        type: 'xy',
      },
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      opacity: 0.8,
    },
    xaxis: {
      tickAmount: 5,
      labels: {
        formatter(val) {
          return parseInt(val);
        },
      },
      min: 0,
      max: 50,
    },
    yaxis: {
      tickAmount: 10,
      labels: {
        formatter(val, index) {
          // if (index === 0 || index === 10) {
          return parseInt(val);
          // }
        },
      },
      min: 0,
      max: 1000,
    },
    legend: {
      show: showBubbleLegend,
    },
    tooltip: {
      enabled: true,
      custom(series) {
        return (
          `${'<div class="arrow_box" style="padding: 10px"><div>'}${
            series.w.globals.initialSeries[series.seriesIndex].name
          }</div>` +
          `<div>${props.intl.formatMessage(messages.amountOfHits)}: <b>${
            series.w.globals.initialSeries[series.seriesIndex].data[series.dataPointIndex][0]
          }</b></div>` +
          `<div>${props.intl.formatMessage(messages.scoreTRI)}: <b>${parseFloat(
            series.w.globals.initialSeries[series.seriesIndex].data[series.dataPointIndex][1],
          ).toFixed(2)}</b></div></div>`
        );
      },
    },
  };

  const optionsApplication = {
    chart: {
      height: 500,
      type: 'scatter',
      zoom: {
        enabled: true,
        type: 'xy',
      },
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      opacity: 0.8,
    },
    xaxis: {
      tickAmount: 5,
      labels: {
        formatter(val) {
          return parseInt(val);
        },
      },
      min: 0,
      max: 50,
    },
    yaxis: {
      tickAmount: 10,
      labels: {
        formatter(val, index) {
          // if (index === 0 || index === 10) {
          return parseInt(val);
          // }
        },
      },
      min: 0,
      max: 1000,
    },
    legend: {
      show: showBubbleLegend,
    },
    tooltip: {
      enabled: false,
    },
  };

  useEffect(() => {
    const aux = toCurricularPerformanceSeries(props.reportStudentTRI.studentAvgs);
    setCurricularPerformance(aux);
  }, [props.reportStudentTRI.studentAvgs]);

  useEffect(() => {
    if (
      props.reportTRI.performanceComparisonByArea ||
      props.reportTRI.performanceComparisonByGroup ||
      props.reportTRI.performanceComparisonBySchool
    ) {
      const performanceComparisonByAreaAux = Object.values(
        props.reportTRI.performanceComparisonByArea ||
          props.reportTRI.performanceComparisonByGroup ||
          props.reportTRI.performanceComparisonBySchool,
      );

      setPerformanceComparisonByArea(performanceComparisonByAreaAux);
    } else {
      setPerformanceComparisonByArea([]);
    }

    if (props.reportTRI.studentsGrade && props.reportTRI.performanceComparison) {
      const studentsGrade = Object.values(props.reportTRI.studentsGrade);
      const filterSchoolsAux = [...new Set(studentsGrade.map((el) => el.groupName))];
      setFilterSchools(filterSchoolsAux);
      setStudentGrade(studentsGrade);
    } else {
      setFilterSchools([]);
      setStudentGrade([]);
    }

    if (props.reportTRI.avgGeneral) {
      setAvgGeneral(props.reportTRI.avgGeneral);
    }
  }, [props.reportTRI]);

  useEffect(() => {
    if (props.bubbleChartCH) {
      setBubbleChartCH(props.bubbleChartCH);
    } else {
      setBubbleChartCH([]);
    }
    if (props.bubbleChartCN) {
      setBubbleChartCN(props.bubbleChartCN);
    } else {
      setBubbleChartCN([]);
    }
    if (props.bubbleChartLC) {
      setBubbleChartLC(props.bubbleChartLC);
    } else {
      setBubbleChartLC([]);
    }
    if (props.bubbleChartMT) {
      setBubbleChartMT(props.bubbleChartMT);
    } else {
      setBubbleChartMT([]);
    }
  }, [props.bubbleChartCH, props.bubbleChartCN, props.bubbleChartLC, props.bubbleChartMT]);

  useEffect(() => {
    let performanceComparisonAux = [];
    if (props.reportPerformanceComparisonSchool.length > 0) {
      performanceComparisonAux = props.reportPerformanceComparisonSchool;
    } else if (props.reportPerformanceComparisonClass.length > 0) {
      performanceComparisonAux = props.reportPerformanceComparisonClass;
    }
    console.log(performanceComparisonAux);

    setPerformanceComparison(performanceComparisonAux);
  }, [props.reportPerformanceComparisonSchool, props.reportPerformanceComparisonClass]);

  useEffect(() => {
    if (
      Object.values(props.reportStudentTRI).length > 0 &&
      Object.values(props.reportStudentCicleTRI).length > 0
    ) {
      const reportStudentCicleTRIAux = Object.values(props.reportStudentCicleTRI);
      const resultAux = [];
      props.reportStudentTRI.studentAvgs.map((el) => {
        resultAux.push({
          area: el.id,
          percentage: el.average,
          application: el.avgAplication,
        });
        return resultAux;
      });
      const performanceComparisonByAreaAux = [
        {
          studentName: props.reportStudentTRI.studentName,
          // avgStudent: props.reportStudentTRI.avgStudent,
          results: resultAux,
        },
      ];

      setPerformanceComparisonByAreaStudent(performanceComparisonByAreaAux);
      setReportStudentCicleTRI(reportStudentCicleTRIAux);
    }
  }, [props.reportStudentTRI, props.reportStudentCicleTRI]);

  const paramsPDF = queryString.parse(window.location.search.replace('?', ''));

  return (
    <div className="report-general-panel">
      <Loader show={loading || loadingApi} />
      <Row className="align-items-end d-print-none">
        <Col md={12}>
          <button className="return" onClick={goBack}>
            <i className="ti-arrow-left" />
            {props.intl.formatMessage(messages.back)}
          </button>
          <h5 className="title">{props.intl.formatMessage(messages.title)}</h5>
        </Col>
      </Row>
      <hr className="d-print-none" />
      <Row className="align-items-center d-print-none">
        <Col md={3} className="column-contract">
          {networkName ? (
            <div className="contract-info">
              <div className="contract-logo">{helpers.getInitials(networkName)}</div>
              <span className="contract-name">{networkName}</span>
            </div>
          ) : (
            <Select
              containerClassName="mt-0"
              nullable
              onChange={handleChangeNetwork}
              options={networkOptions}
              placeholder={props.intl.formatMessage(messages.chain)}
            />
          )}
        </Col>
        <Col md={2} className="column-filters">
          <Select
            containerClassName="mt-0"
            disabled={!filter.idNetwork}
            nullable
            name="idEvaluation"
            onChange={handleChangeEvaluation}
            value={filter.idEvaluation}
            options={evaluationOptions}
            placeholder={props.intl.formatMessage(messages.application)}
          />
        </Col>
        <Col md={3} className="column-filters">
          <Select
            containerClassName="mt-0"
            disabled={!filter.idEvaluation}
            nullable
            name="idCSchool"
            onChange={handleChangeSchool}
            value={filter.idCSchool}
            options={schoolOptions}
            placeholder={props.intl.formatMessage(messages.school)}
          />
        </Col>
        <Col md={2} className="column-filters">
          <Select
            containerClassName="mt-0"
            disabled={!filter.idCSchool}
            nullable
            name="idESCourse"
            value={filter.idESCourse}
            onChange={handleChangeCourse}
            options={courseOptions}
            placeholder={props.intl.formatMessage(messages.class)}
          />
        </Col>
        <Col md={2} className="column-filters">
          <Select
            containerClassName="mt-0"
            disabled={!filter.idESCourse}
            nullable
            name="idESUser"
            value={filter.idESUser}
            onChange={handleChangeStudent}
            options={studentOptions}
            placeholder={props.intl.formatMessage(messages.students)}
          />
        </Col>
      </Row>
      <Row>
        <Col
          md={12}
          className="d-flex justify-content-end column-filters"
          style={{ marginTop: '20px' }}
        >
          <Button primary className="small-button d-print-none" onClick={generatePdf}>
            {props.intl.formatMessage(messages.generatePdf)}
          </Button>
        </Col>
      </Row>
      <hr className="d-print-none" />
      <div>{!filter.idEvaluation && props.intl.formatMessage(messages.selectOptionsAbove)}</div>
      <div id="divToPDF" className="divToPDF">
        {filter.idESUser ? (
          <StudentDetailCard
            studentName={studentName}
            cardDetailStudentTRI={props.cardDetailStudentTRI}
          />
        ) : (
          filter.idEvaluation &&
          Object.keys(props.cardDetailTRI).length > 0 && (
            <GeneralDetailCard
              cardDetailTRI={props.cardDetailTRI}
              schoolCard={filter.idCSchool && !filter.idESCourse}
              applicationCard={filter.idEvaluation && !filter.idCSchool}
            />
          )
        )}
        {filter.idEvaluation && (
          <div>
            {performanceComparisonByAreaStudent.length > 0 && filter.idESUser !== '' ? (
              <Chart
                area={performanceComparisonByAreaStudent}
                title={props.intl.formatMessage(messages.performanceComparisonByAreaStudentXApp)}
                titleColor="#ea654b"
                isStudentTRI
                isReportTRI
                avgByAreaMessage={props.intl.formatMessage(messages.avgByAreaMessage)}
              />
            ) : (
              <Chart
                area={performanceComparisonByArea}
                title={props.intl.formatMessage(messages.comparativePerformanceByArea)}
                titleColor="#ea654b"
                isStudentTRI={false}
                isReportTRI
                isSchoolView={filter.idCSchool}
                isApplicationView={filter.idEvaluation && !filter.idCSchool}
                avgByAreaMessage={props.intl.formatMessage(messages.avgByAreaMessage)}
                avgGeneral={avgGeneral}
              />
            )}

            {filter.idCSchool && !filter.idESUser && (
              <PerformanceStudentsComparative
                title={props.intl.formatMessage(messages.heatMapStudentsPerformance)}
                itens={studentGrade}
                school={schoolName}
                squareSize={{ maxWidth: '12.5%', flex: '0 0 12.5%' }}
                size={60}
                isTRI
                filterHeatMap={filterSchools}
                tabsHeatMap
                limit={limit}
                expanded={expanded}
              />
            )}
            <PerformanceStudentsComparative
              title={props.intl.formatMessage(messages.heatQuestionsMap)}
              itens={
                Object.keys(props.reportStudentTRI).length > 0
                  ? props.reportStudentTRI.studentPerformance
                  : props.reportTRI.contentQuestionsDetail
              }
              school={schoolName}
              squareSize={{ maxWidth: '25%', flex: '0 0 20%' }}
              size={150}
              limit={limit}
              expanded={expanded}
              filter={filter}
              TRI
              tabs
            />
            {!filter.idESUser && (
              <div>
                {bubbleChartCH && (
                  <Card
                    style={{ width: '100%' }}
                    className="chart-mobile report-bar-chart--container"
                  >
                    <div
                      style={{ color: '#ea654b', display: 'flex', justifyContent: 'space-between' }}
                    >
                      <strong>
                        <i className="pe-7s-graph1 mr-2" />
                        {props.intl.formatMessage(messages.bubbleChartHeats)} - CH
                      </strong>

                      <div style={{ textAlign: 'right', fontWeight: 'bold', marginBottom: '10px' }}>
                        <div>{props.intl.formatMessage(messages.lineBubbleLabel)}</div>
                        <div>{props.intl.formatMessage(messages.columnBubbleLabel)}</div>
                      </div>
                    </div>
                    <BubbleChart
                      options={!filter.idCSchool ? optionsApplication : options}
                      series={bubbleChartCH}
                      type="scatter"
                      height={500}
                      width={Object.keys(paramsPDF).length > 0 ? 900 : '100%'}
                    />
                  </Card>
                )}
                {bubbleChartCN && (
                  <Card
                    style={{ width: '100%' }}
                    className="chart-mobile report-bar-chart--container"
                  >
                    <div
                      style={{ color: '#ea654b', display: 'flex', justifyContent: 'space-between' }}
                    >
                      <strong>
                        <i className="pe-7s-graph1 mr-2" />
                        {props.intl.formatMessage(messages.bubbleChartHeats)} - CN
                      </strong>

                      <div style={{ textAlign: 'right', fontWeight: 'bold', marginBottom: '10px' }}>
                        <div>{props.intl.formatMessage(messages.lineBubbleLabel)}</div>
                        <div>{props.intl.formatMessage(messages.columnBubbleLabel)}</div>
                      </div>
                    </div>
                    <BubbleChart
                      options={!filter.idCSchool ? optionsApplication : options}
                      series={bubbleChartCN}
                      type="scatter"
                      height={500}
                      width={Object.keys(paramsPDF).length > 0 ? 900 : '100%'}
                    />
                  </Card>
                )}
                {bubbleChartLC && (
                  <Card
                    style={{ width: '100%' }}
                    className="chart-mobile report-bar-chart--container"
                  >
                    <div
                      style={{ color: '#ea654b', display: 'flex', justifyContent: 'space-between' }}
                    >
                      <strong>
                        <i className="pe-7s-graph1 mr-2" />
                        {props.intl.formatMessage(messages.bubbleChartHeats)} - LC
                      </strong>

                      <div style={{ textAlign: 'right', fontWeight: 'bold', marginBottom: '10px' }}>
                        <div>{props.intl.formatMessage(messages.lineBubbleLabel)}</div>
                        <div>{props.intl.formatMessage(messages.columnBubbleLabel)}</div>
                      </div>
                    </div>
                    <BubbleChart
                      options={!filter.idCSchool ? optionsApplication : options}
                      series={bubbleChartLC}
                      type="scatter"
                      height={500}
                      width={Object.keys(paramsPDF).length > 0 ? 900 : '100%'}
                    />
                  </Card>
                )}
                {bubbleChartMT && (
                  <Card
                    style={{ width: '100%' }}
                    className="chart-mobile report-bar-chart--container"
                  >
                    <div
                      style={{ color: '#ea654b', display: 'flex', justifyContent: 'space-between' }}
                    >
                      <strong>
                        <i className="pe-7s-graph1 mr-2" />
                        {props.intl.formatMessage(messages.bubbleChartHeats)} - MT
                      </strong>

                      <div style={{ textAlign: 'right', fontWeight: 'bold', marginBottom: '10px' }}>
                        <div>{props.intl.formatMessage(messages.lineBubbleLabel)}</div>
                        <div>{props.intl.formatMessage(messages.columnBubbleLabel)}</div>
                      </div>
                    </div>
                    <BubbleChart
                      options={!filter.idCSchool ? optionsApplication : options}
                      series={bubbleChartMT}
                      type="scatter"
                      height={500}
                      width={Object.keys(paramsPDF).length > 0 ? 900 : '100%'}
                    />
                  </Card>
                )}
              </div>
            )}
            {filter.idESUser && curricularPerformance.length > 0 && (
              <ChartPerformance
                title={props.intl.formatMessage(messages.performanceComparison)}
                titleColor="#ea654b"
                series={curricularPerformance}
                barWidth={25}
                isStudentTRI
              />
            )}
            {filter.idESUser && reportStudentCicleTRI && (
              <AssessmentCycleTable
                items={reportStudentCicleTRI}
                title={props.intl.formatMessage(messages.comparisonOfAverageScoreByApplication)}
                isStudentTRI
              />
            )}
            {filter.idCSchool && !filter.idESUser && (
              <AvgRankingTable
                data={performanceComparison}
                idESCourse={filter.idESCourse}
                isSchoolView={!filter.idESCourse}
                exportXLSX={() => handleExportXLSX()}
                expanded={expanded}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

ReportGeneralPanelTRIContainer.propTypes = {};

const mapStateToProps = ({ reportGeneralTRIPanel, app }, { match }) => ({
  ...match.params,
  ...reportGeneralTRIPanel,
  token: app.cookieToken,
  permission: app.permission,
});

export default compose(
  injectIntl,
  withRouter,
  connect(
    mapStateToProps,
    promisify(
      { ...actions, ...generalTRIActions },
      {
        include: [
          'generatePdf',
          'getESFilterTRI',
          'getESTRIDetail',
          'getESTRIStudentDetail',
          'getESReportTRI',
          'getESStudentReportTRI',
          'getESEvaluationsCicleStudentTRI',
          'generateReportTRI',
          'getQuestionsDetailTRI',
          'getESSchoolReportTRI',
          'generateSchoolReportTRI',
          'getESTRISchoolDetail',
          'getESApplicationReportTRI',
          'getESTRIApplicationDetail',
        ],
      },
    ),
  ),
)(ReportGeneralPanelTRIContainer);
